import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDITUtuSMobNivoZXU8Wc3dz6B2vhCWGb4",
  authDomain: "tc-booking-3d3f8.firebaseapp.com",
  projectId: "tc-booking",
  storageBucket: "tc-booking.firebasestorage.app",
  messagingSenderId: "625489809954",
  appId: "1:625489809954:web:c2b0fd0a0f1c934154707b"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
